import React, { useState } from "react";
import { Modal } from "antd";
import PaginationLog from "../../Log/PaginationLog";
import { PriceChangeListParsed } from "../../../../typings/interfaces";

export interface PriceChangesProps {
  show: boolean;
  onPriceChangesClose: () => void;
  onPriceChangesPageChange: (page: number, callback?: () => void) => void;
  values: PriceChangeListParsed;
}

const PriceChanges = (props: PriceChangesProps) => {
  const {
    show,
    onPriceChangesClose,
    onPriceChangesPageChange,
    values,
  } = props;

  const [loading, setIsLoading] = useState(false);

  const handlePageChange = page => {
    setIsLoading(true);
    onPriceChangesPageChange(page, () => {
      setIsLoading(false);
    });
  }

  return (
    <Modal
      title={"Povijest promjena cijena"}
      visible={show}
      footer={null}
      onCancel={() => {
        onPriceChangesClose();
      }}
    >
      <PaginationLog
        columns={[
          {
            title: "Datum",
            dataIndex: 'date',
            key: 'date',
          },
          {
            title: "Postotak",
            dataIndex: 'percentage',
            key: 'percentage',
          },
          {
            title: "Stara cijena",
            dataIndex: 'priceFrom',
            key: 'priceFrom',
          },
          {
            title: "Nova cijena",
            dataIndex: 'priceTo',
            key: 'priceTo',
          },
        ]}
        log={values}
        loading={loading}
        emptyLogText={"Nema loga za prikazat."}
        handlePageChange={handlePageChange}
        responsiveProps={{
          xs: 24
        }}
      />

    </Modal>
  );
};

export default PriceChanges;



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdPage/PriceChanges/PriceChanges.tsx